import React, { useContext, useState } from 'react';
import { ContextProps } from '../types/ContextProps';
import { EventTypeData } from '../types/ViewModel/EventTypeData';
import { EventType } from '../types/ViewModel/EventType';
import { ToolboxQueryInfo } from '../types/ViewModel/ToolboxQueryInfo';

type EventTypeContextType = {
    eventTypeData: EventTypeData | null;
    eventTypeDataPort: EventTypeData | null;
    eventTypeDataSea: EventTypeData | null;
    eventTypeArray: EventType[];
    selectedEventType: EventType | null;
    toolboxQueryInfo: ToolboxQueryInfo | null;
    setEventTypeData: (eventTypeData: EventTypeData) => void;
    setEventTypeDataPort: (eventTypeData: EventTypeData) => void;
    setEventTypeDataSea: (eventTypeData: EventTypeData) => void;
    setEventTypeArray: (evTypeArray: EventType[]) => void;
    setSelectedEventType: (eventType: EventType | null) => void;
    setToolboxQueryInfo: (toolboxQueryInfo: ToolboxQueryInfo | null) => void;
};

export const EventTypeContext = React.createContext<EventTypeContextType>(undefined!);

export const EventTypeProvider = ({ children }: ContextProps) => {
    const [eventTypeData, setEventTypeData] = useState<EventTypeData | null>(null);
    const [eventTypeDataPort, setEventTypeDataPort] = useState<EventTypeData | null>(null);
    const [eventTypeDataSea, setEventTypeDataSea] = useState<EventTypeData | null>(null);
    const [eventTypeArray, setEventTypeArray] = useState<EventType[]>([]);
    const [selectedEventType, setSelectedEventType] = useState<EventType | null>(null);
    const [toolboxQueryInfo, setToolboxQueryInfo] = useState<ToolboxQueryInfo | null>(null);
    return (
        <EventTypeContext.Provider
            value={{
                eventTypeData,
                setEventTypeData,
                eventTypeDataPort,
                setEventTypeDataPort,
                eventTypeDataSea,
                setEventTypeDataSea,
                eventTypeArray,
                setEventTypeArray,
                selectedEventType,
                setSelectedEventType,
                toolboxQueryInfo,
                setToolboxQueryInfo,
            }}
        >
            {children}
        </EventTypeContext.Provider>
    );
};

export const useEventTypeStore = () => useContext(EventTypeContext);
